import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, HostListener, Inject, Renderer2, AfterContentInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgForm } from '@angular/forms';
import { AdminService } from '../admin.service';
import { DatePipe } from '@angular/common';
import * as Quill from 'quill';
import { Flow, Control, Step, PhoneCompatibility, Troubleshoot, Badges, FAQ } from '../../shared/models/Flow';
import { ImageRequest } from '../../shared/models/Flow';
import { Observable, Subject } from 'rxjs';
import { TCCPConstantValues } from '../../shared/models/tccp-constants';
import { TCCPCommonService } from '../../shared/services/tccp-common.service';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { Content } from 'src/modules/shared/models/content';
import { environment } from '../../../environments/environment';
import { TCCPLocalStorageService } from '../../shared/services/tccp-local-storage.service';
import { PreviewImageComponent } from '../../shared/components/preview-image/preview-image.component';
import * as _ from 'lodash';
import { FLAG_UNRESTRICTED } from 'html2canvas/dist/types/css/syntax/tokenizer';


@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss']
})
export class StepComponent implements OnInit {
  public imageOptionType = 'addImages';
  public isImageFromS3 = false;
  public playStoreChecked = false;
  public appStoreChecked = false;
  public androidLink = '';
  public iosLink = '';
  public editor;
  public troubleshootEditor;
  public faqEditor;
  public editorOptions;
  public selectedApp = this.adminService.selectedApplication;
  public deleteImageOrVideo = '';
  public dateInfo = '';
  public initialFlowInfomation: any = {};
  public edit: Subject<boolean> = new Subject<boolean>();
  public showNotes = false;
  public showTroubleshooting = false;
  public showError = false;
  public selectedS3ImageList = [];
  public selectedStepIndex = 0;
  public hasStepCopyChecked = false;
  public showFAQ = false;  

  stepFormDetails: Flow = <Flow>({
    tagName: null,
    informationOrQuestion: null,
    issueId: null,
    controls: [],
    targetId: null,
    imagesOrVideos: [],
    type: null,
    notes: null,
    lastModifiedDate: null,
    troubleshoot: <Troubleshoot>{},
    badges: [],
    isImageFromS3: false,
    faqs: <FAQ>{}
  });
  public showAddButton = false;
  public flow: Flow;
  public step: Step;
  public controls: Control;
  public imageSrc = '';
  public videoSrc = '';
  public filename = '';
  public showAddFeature: boolean;
  public icon = '';
  public type: string;
  public controlName: string;
  public enteredControlName: string;
  public tileName: string;
  public deleteTileName: string;
  public alerts: any[] = [];
  public showStepTypeError = false;
  public thumbnilPath: string = null;
  public pageTitle = '';
  public tileInformation: Control;
  public tagNames: any;
  public features: any;
  public selectedTagName = '';
  public selectedFeature = '';
  public selectedDivision = '';
  public fileContent: string | ArrayBuffer;
  public editorStyle = {
    width: '100%',
    height: '200px',
    readonly: true
  };
  public isEditControl = false;
  public isUpdateControl = false;
  public isTileControl = false;
  public editControlIndex: number;
  public isViewMode = false;
  public isEditMode = false;
  public isAddMode = true;
  public isDisableSetp = true;
  public isDisableCopy = true;
  public isFileNameValidated = false;
  public imageName = '';
  public deleteControls: any = {};
  public controlCount: number;
  public tileCount: number;
  public featureName: string;
  public markAsLastStep: boolean;
  public tagNamesByFeature: any;
  public nodeDetails = {};
  public isHomeCurrentStep = false;
  public addStepClicked: boolean;
  public deleteChildren: any = [];
  public isLastStepInFlow: boolean;
  public hasContentSpliter = false;
  public isControlAsTile = false;
  public contents: Content[];
  public isPreview = false;
  public previwUrl: string;
  public activeFeatureStatus: string;
  public initialImageName = '';
  public infoOpenState = false;
  public contentOpenState = true;
  public controlsOpenState;
  public hasImagesOrVideos = false;
  public hasControls = false;
  public hasTiles = false;
  public textMax = 206;
  public notesLength = '';
  public badgeList = this.commonService.getBadgeNames(this.selectedApp);
  public googleBadge : string = this.getBadgeName('google');
  public appleBadge : string = this.getBadgeName('apple');
  public saveTileOptions: any;
 

  
  playStoreCheck(event: MatCheckboxChange) {
    this.playStoreChecked = event.checked;
    if (!this.playStoreChecked) {
      this.androidLink = '';
    }
  }

  appStoreCheck(event: MatCheckboxChange) {
    this.appStoreChecked = event.checked;
    if (!this.appStoreChecked) {
      this.iosLink = '';
    }
  }

  setBadges(list: Flow) {

    this.playStoreChecked = false;
    this.appStoreChecked = false;
    this.androidLink = '';
    this.iosLink = '';
    if (list.badges) {
      let androidList: Badges[] = [];
      androidList = list.badges.filter(badge => (badge.badgeName === 'badges-google'));
      let appleList: Badges[] = [];
      appleList = list.badges.filter(badge => (badge.badgeName === 'badges-apple'));
      if (androidList.length !== 0) {
        this.playStoreChecked = true;
        this.androidLink = androidList[0].link;
      }
      if (appleList.length !== 0) {
        this.appStoreChecked = true;
        this.iosLink = appleList[0].link;
      }
    } else {
      this.playStoreChecked = false;
      this.appStoreChecked = false;
      this.androidLink = '';
      this.iosLink = '';
    }
  }

  @ViewChild('stepForm', { static: true }) stepForm: ElementRef;

  constructor(
    public adminService: AdminService, private datePipe: DatePipe,
    private router: Router, private dialog: MatDialog, private renderer: Renderer2,
    private storageService: TCCPLocalStorageService, public commonService: TCCPCommonService) {
    this.showNotes = false;
    this.showTroubleshooting = false;
    this.showFAQ = false;
    this.selectedApp = this.adminService.selectedApplication;
    this.adminService.navigateToFlow.subscribe(modeDetails => {
      if (modeDetails) {
        this.setPageMode(modeDetails);
      }
    });

    // Add fonts to whitelist
    const fontNames = this.selectedApp === 'toyota' ? ['toyota-semibold', 'toyota-regular',
      'toyota-bold', 'toyota-light', 'toyota-black', 'toyota-book'] :
      ['nobel-regular', 'nobel-bold', 'nobel-light', 'nobel-book'];

    const Font = Quill.import('attributors/style/font');
    Font.whitelist = fontNames;
    Quill.register(Font, true);
    const Inline = Quill.import('blots/inline');
    const InlineBlot = Quill.import('blots/block')
    class SpanBlock extends Inline {
      static create() {
        const node = super.create();
        node.setAttribute('class', 'disclaimer-block');
        node.addEventListener('click', (e) => {
          this.openDisclaimernumber(e.srcElement.innerText);
        });
        node.setAttribute('style', 'color:blue; cursor: pointer;vertical-align: super;');
        return node;
      }
    }
    SpanBlock.blotName = 'spanblock';
    SpanBlock.tagName = 'spanblock';
    Quill.register(SpanBlock);

    class FontBlock extends Inline {
      static create() {
        const node = super.create();
        node.setAttribute('class', 'font-block');
        node.setAttribute('[matMenuTriggerFor]', 'basicmenu');
        /*  node.addEventListener('click', (e) => {
           this.openDisclaimernumber(e.srcElement.innerText);
         }); */
        node.setAttribute('style', 'color:blue; cursor: pointer;');
        return node;
      }
    }
    FontBlock.blotName = 'fontblock';
    FontBlock.tagName = 'fontblock';
    Quill.register(FontBlock);

    const fontSizeArr = ['8px', '9px', '10px', '12px', '14px', '16px', '20px', '24px'];

    /* var Size = Quill.import('attributors/style/size');
    Size.whitelist = ['12px', '16px', '18px'];
    Quill.register(Size, true); */

    const toolbarOptions = [
      ['underline'],        // toggled buttons
      // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],      // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }],          // outdent/indent

      // dropdown with defaults from theme
      [{ font: fontNames }],
      [{ align: ['justify', 'center', 'right'] }],
      [{ disclaimer: 1 }],
      [{ color: ['#ffffff', '#000000', '#EB0A1E', '#58595B', '#b6a171'] }],
      /*  [{ 'youtubevideo': 1 }], */
      ['video'],
      ['link'],
      [{ size: ['small', false, 'large', 'huge'] }]
    ];
    this.editorOptions = {
      toolbar: toolbarOptions
    };
  }

  

  autoSizeTextArea(event?) {
    if (event) {
      event.target.style.height = '0';
      event.target.style.height = `${event.target.scrollHeight + 25}px`;
    }
    else {
      const textEle = document.getElementById('autosize-textarea');
      textEle.style.height = '0';
      textEle.style.height = `${textEle.scrollHeight + 25}px`;
    }
  }

  public openDashBorad() {
    this.adminService.closeFeatureExpansionPanel.emit(true);
    this.router.navigateByUrl('/admin');
  }

  openDisclaimernumber(e: any) {
  }

  ngOnInit() {
  
    this.isViewMode = false;
    this.isEditMode = false;
    this.isAddMode = false;
    let modeDetails = {};
    this.controlCount = 0;
    this.tileCount = 0;
    this.showNotes = false;
    this.showTroubleshooting = false;
    this.featureName = this.adminService.activeFeature;
    this.activeFeatureStatus = this.adminService.activeFeatureStatus;
    this.selectedDivision = this.adminService.selectedApplication;
    if (this.adminService.isStepInViewMode) {
      this.isViewMode = true;
      modeDetails = { mode: TCCPConstantValues.admin.FIXED_VALUES.VIEW, fromAdmin: true };
      this.pageTitle = TCCPConstantValues.admin.FIXED_VALUES.VIEW_STEP;
      this.setPageMode(modeDetails);
    } else {
      this.isAddMode = true;
      modeDetails = { mode: TCCPConstantValues.admin.FIXED_VALUES.ADD, fromAdmin: false };
      this.pageTitle = TCCPConstantValues.admin.FIXED_VALUES.ADD_STEP;
      this.setPageMode(modeDetails);
    }
    this.thumbnilPath = TCCPConstantValues.admin.Urls.IMAGE_PATH;
  }

  retainFormatting() {
  }

  onEditorCreated(quill) {
    this.editor = quill;
    this.retainFormatting();
  }

  onTroubleshootEditorCreated(quill) {
    this.troubleshootEditor = quill;
    const el = document.querySelectorAll('.ql-disclaimer');
    if (el.length > 1) {
      const last = el[el.length - 1];
      this.renderer.addClass(last, 'fa');
      this.renderer.addClass(last, 'fa-comments-o');
      this.renderer.listen(last, 'click', () => {
        this.openTroubleshootDisclaimer();
      });
    }
  }

  onFAQEditorCreated(quill) {
    this.troubleshootEditor = quill;
    const el = document.querySelectorAll('.ql-disclaimer');
    if (el.length > 1) {
      const last = el[el.length - 1];
      this.renderer.addClass(last, 'fa');
      this.renderer.addClass(last, 'fa-comments-o');
      this.renderer.listen(last, 'click', () => {
        this.openFAQ();
      });
    }
  }

  setPageMode(modeDetails?: any) {
    this.infoOpenState = false;
    this.contentOpenState = true;
    //  this.controlsOpenState = true;
    if (this.adminService.selectedNode['item'] && this.adminService.selectedNode['item']['controlName']) {
      this.isHomeCurrentStep = this.adminService.selectedNode['item']['controlName'].toLowerCase() === 'home';
    }
    this.featureName = this.adminService.activeFeature;
    this.activeFeatureStatus = this.adminService.activeFeatureStatus;
    // on page load existing Feature should allow fresh select and steps dropdown empty
    this.getAllTagName();
    this.selectedFeature = null;
    this.selectedTagName = null;
    this.tagNames = null;
    this.getAllFeature();
    this.getAllDocuments();

    if (modeDetails) {
      this.isViewMode = this.isAddMode = this.isEditMode = false;
      if (modeDetails.mode === TCCPConstantValues.admin.FIXED_VALUES.ADD) {
        this.infoOpenState = true;
        this.contentOpenState = false;
        this.isAddMode = true;
        this.pageTitle = TCCPConstantValues.admin.FIXED_VALUES.ADD_STEP;
        this.alerts = [];
        this.tileName = null;
        this.controlName = null;
        this.enteredControlName = null;
        const flow = <Flow>(
          {
            tagName: null, informationOrQuestion: null, issueId: null, controls: [],
            targetId: null, imagesOrVideos: [], type: null, notes: null, lastModifiedDate: null, isLastStep: null,
            troubleshoot: <Troubleshoot>{}, badges: [], faqs: <FAQ>{}
          });
        this.stepFormDetails = flow;
        this.stepFormDetails.troubleshoot.troubleshootingSteps = null;
        this.stepFormDetails.faqs.faqs = null;
        this.stepFormDetails.hasContentSpliter = false;
        this.stepFormDetails.isControlAsButton = false;
        this.hasContentSpliter = false;
        this.isControlAsTile = false;
        this.showNotes = false;
        this.showTroubleshooting = false;
        this.showFAQ = false;
        this.playStoreChecked = false;
        this.appStoreChecked = false;
        this.androidLink = '';
        this.iosLink = '';
      } else if (modeDetails.mode === TCCPConstantValues.admin.FIXED_VALUES.VIEW) {
        this.isViewMode = true;
        this.pageTitle = TCCPConstantValues.admin.FIXED_VALUES.VIEW_STEP;
        if (modeDetails.fromAdmin) {
          this.alerts = [];
          this.getSubFeatureFlow(this.adminService.selectedStepIssueId);
        } else {
          const index = this.adminService.expandedNode.findIndex(node => node === modeDetails.currentNode);
          if (index === -1) {
            this.adminService.expandedNode.push(modeDetails.currentNode);
          }
          this.callrefreshFeatureTree(
            {
              node: this.adminService.expandedNode,
              issueId: this.stepFormDetails.issueId,
              type: 'step',
              action: modeDetails.action
            });
        }
      } else if (modeDetails.mode === TCCPConstantValues.admin.FIXED_VALUES.EDIT) {
        this.pageTitle = TCCPConstantValues.admin.FIXED_VALUES.EDIT_STEP;
        this.isEditMode = true;
        this.isViewMode = this.isAddMode = false;
        this.stepFormDetails.troubleshoot.troubleshootingSteps = this.stepFormDetails.troubleshoot.troubleshootingSteps ?
          this.stepFormDetails.troubleshoot.troubleshootingSteps : null;
        this.stepFormDetails.faqs.faqs = this.stepFormDetails.faqs.faqs ?
          this.stepFormDetails.faqs.faqs : null;
      }
      this.initialFlowInfomation = Object.assign({}, this.stepFormDetails);
    }
  }

  callrefreshFeatureTree(nodeDetails): void {
    this.adminService.callrefreshFeatureTree(nodeDetails);
  }

  editorContentCreated(quill) {
    this.editor = quill;
  }

  /*
  flowId - issueId of the step to be retrieved
  fromTagName - tells if the flowId belongs to the source step[when fromTagName===true]. when onCopyStep event is fired. 
  */
  public getSubFeatureFlow(flowId: string, fromTagName?: boolean) {
    this.adminService.getSubFeatureFlow(flowId, this.selectedDivision).subscribe(response => {
      if (response) {
        const userEnteredText = this.stepFormDetails.tagName;
        // before change step log the current state of step
        this.initialFlowInfomation = Object.assign({}, this.stepFormDetails);
        this.stepFormDetails = response.Item;
        this.stepFormDetails.isImageFromS3 = response.Item.isImageFromS3 === undefined ? false : response.Item.isImageFromS3;
        this.setBadges(response.Item);
        this.isImageFromS3 = response.Item.isImageFromS3 === undefined ? false : response.Item.isImageFromS3;
        this.imageOptionType = this.isImageFromS3 ? 'selectImages' : 'addImages';
        this.stepFormDetails.troubleshoot = this.stepFormDetails.troubleshoot ? this.stepFormDetails.troubleshoot : <Troubleshoot>{};
        this.stepFormDetails.faqs = this.stepFormDetails.faqs ? this.stepFormDetails.faqs : <FAQ>{};

        const buttonControls = this.stepFormDetails.controls.filter(x => x.controlType === 'button');
        this.hasControls = buttonControls.length > 0;
        const tileControls = this.stepFormDetails.controls.filter(x => x.controlType === 'tile');
        this.hasTiles = tileControls.length > 0;

        const hasImages = this.stepFormDetails.imagesOrVideos && this.stepFormDetails.imagesOrVideos.length > 0;
        const currentImagesOrVideos = hasImages ? this.stepFormDetails.imagesOrVideos : null;
        this.hasImagesOrVideos = hasImages;


        if (fromTagName) {
          // Step page name should be retain after click on Copy
          this.stepFormDetails.tagName = userEnteredText;
          this.stepFormDetails.imagesOrVideos = this.hasImagesOrVideos ? currentImagesOrVideos : this.stepFormDetails.imagesOrVideos;
        }
        this.editor.setContents(this.editor.clipboard.convert(this.stepFormDetails.informationOrQuestion));
        // this.getYoutubeURLs();
        this.showNotes = this.stepFormDetails.notes ? true : false;
        if(this.showNotes){
          if((this.textMax -this.stepFormDetails.notes.length)<10){
            this.notesLength = ('0'+ (this.textMax - this.stepFormDetails.notes.length)).slice(-2);
          }else{
          this.notesLength = (this.textMax - this.stepFormDetails.notes.length).toString();
          }
        }
        this.showTroubleshooting = this.stepFormDetails.troubleshoot.troubleshootingSteps ? true : false;
        this.showFAQ = this.stepFormDetails.faqs.faqs ? true : false;
        this.dateInfo = this.datePipe.transform(this.stepFormDetails.lastModifiedDate, TCCPConstantValues.admin.FIXED_VALUES.DATE_FORMAT);
        this.markAsLastStep = this.stepFormDetails.isLastStep ? true : false;
        this.hasContentSpliter = this.stepFormDetails.hasContentSpliter ? true : false;
        this.isControlAsTile = this.stepFormDetails.isControlAsButton ? false : true;
        //  this.isControlAsTile = this.stepFormDetails.isControlAsButton;
      }
    });
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    this.isEditMode = false;
    this.adminService.addStepClicked = true;
    this.alerts = [];
    const areSame: boolean = JSON.stringify(this.initialFlowInfomation) === JSON.stringify(this.stepFormDetails);
    if ((this.isEditMode || this.isAddMode) && areSame === false) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
        position: { top: '100px' },
        id: 'admin-' + this.adminService.selectedApplication
      });
      return dialogRef.afterClosed();
    } else {
      return true;
    }
  }

  public mandatoryCheck() {
    let isValid = false;
    if (this.isAddMode || this.isEditMode) {
      let tagIndex = -1;
      if (!this.stepFormDetails.tagName || this.stepFormDetails.tagName === '') {
        isValid = false;
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.PAGENAME_ERROR_MESSAGE);
        this.infoOpenState = true;
        this.contentOpenState = false;
        return isValid;
      }
      if (this.stepFormDetails.tagName) {
        this.tagNames.forEach((item, i) => {
          if (this.stepFormDetails.issueId) {
            if (item.issueId === this.stepFormDetails.issueId) {
              this.tagNames.splice(i, 1);
            } else {
              if (item.tagName === this.stepFormDetails.tagName) {
                return tagIndex = i;
              }
            }
          } else {
            if (item.tagName === this.stepFormDetails.tagName) {
              return tagIndex = i;
            }
          }
        });
      }
      if (tagIndex === -1) {
        isValid = true;
      } else {
        isValid = false;
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.PAGENAME_EXISTS_MESSAGE);
        this.infoOpenState = true;
        this.contentOpenState = false;
        return isValid;
      }
    }

    if (this.showNotes && (this.stepFormDetails.notes == null || this.stepFormDetails.notes === '')) {
      isValid = false;
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.NOTES_ERROR_MESSAGE);
      this.infoOpenState = false;
      this.contentOpenState = true;
      return isValid;
    } else {
      isValid = true;
    }
    if (!this.showNotes) {
      isValid = true;
    }
    return isValid;
  }

  public onChangeStepType(type) {
    this.stepFormDetails = type;
    this.showStepTypeError = type ? false : true;
  }
  public onClosed() {
    this.alerts = [];
  }

  findImageName(imagePath) {
    let imageName;
    if (imagePath.indexOf('/') > -1) {
      imageName = imagePath.split('/');
    } else {
      imageName = imagePath.split('%2F');
    }

    return imageName && imageName.length > 0 ? imageName[imageName.length - 1] : '';
  }

  onSave(myForm: NgForm) {
    this.adminService.addStepClicked = false;
    this.showError = true;
    this.showStepTypeError = this.stepFormDetails ? false : true;
    this.deleteChildren.forEach((item) => {
      this.adminService.deleteFeatureFlow(item.issueId).subscribe(() => {
        this.showError = false;
        this.markAsLastStep = true;
        this.callrefreshFeatureTree({
          node: this.adminService.expandedNode,
          issueId: item.issueId,
          type: 'step',
          action: 'delete'
        });
      });
    });
    if (this.initialFlowInfomation.issueId !== this.stepFormDetails.issueId) {
      this.stepFormDetails.issueId = this.initialFlowInfomation.issueId;
      this.stepFormDetails.targetId = this.initialFlowInfomation.targetId;
    }
    if (this.mandatoryCheck()) {
      this.alerts = [];
      // checking if issueId of the data is of the destination step

      const requestData: Flow = <Flow>(this.stepFormDetails);
      requestData.type = 'step';
      this.isImageFromS3 = this.imageOptionType === 'selectImages' ? true : false;
      requestData.isImageFromS3 = this.isImageFromS3;
      if (requestData.imagesOrVideos === undefined) {
        requestData.imagesOrVideos = [];
      }
      if (requestData.targetId === undefined) {
        requestData.targetId = null;
      }
      if (requestData.isImageFromS3 === undefined) {
        requestData.isImageFromS3 = false;
      }
      if (requestData.notes === undefined || requestData.notes === '') {
        requestData.notes = null;
      }
      if (requestData.controls === undefined) {
        requestData.controls = [];
      }
      if (requestData.lastModifiedDate === undefined) {
        requestData.lastModifiedDate = null;
      }
      if (requestData.featureType === undefined) {
        requestData.featureType = null;
      }
      if (requestData.hasContentSpliter === undefined) {
        requestData.hasContentSpliter = null;
      }
      requestData.hasContentSpliter = this.hasContentSpliter ? true : false;
      requestData.isControlAsButton = this.isControlAsTile ? false : true;
      // requestData.isControlAsButton = this.isControlAsTile;
      if (this.markAsLastStep === true) {
        requestData.isLastStep = true;
        requestData.targetId = null;
      } else {
        requestData.isLastStep = false;
      }

      if (this.playStoreChecked) { // optimize the code for both
        if (!requestData.badges) {
          requestData.badges = [];
          requestData.badges.push({ badgeName: 'badges-google', link: this.androidLink });
        } else {
          let link: Badges[] = [];
          link = requestData.badges.filter(badge => (badge.badgeName === 'badges-google'));
          if (link.length === 0) {
            requestData.badges.push({ badgeName: 'badges-google', link: this.androidLink });
          } else if (link[0].link !== this.androidLink) {
            requestData.badges.forEach(badge => (badge.badgeName === 'badges-google'))[0].link = this.androidLink;
          }
        }
      } else {
        if (requestData.badges) {
          const index = requestData.badges.findIndex(x => x.badgeName === 'badges-google');
          if (index >= 0) {
            requestData.badges.splice(index, 1);
          }
        }
      }

      if (this.appStoreChecked) {
        if (!requestData.badges) {
          requestData.badges = [];
          requestData.badges.push({ badgeName: 'badges-apple', link: this.iosLink });
        } else {
          let link: Badges[] = [];
          link = requestData.badges.filter(badge => (badge.badgeName === 'badges-apple'));
          if (link.length === 0) {
            requestData.badges.push({ badgeName: 'badges-apple', link: this.iosLink });
          } else if (link[0].link !== this.iosLink) {
            requestData.badges.forEach(badge => (badge.badgeName === 'badges-apple'))[0].link = this.iosLink;
          }
        }
      } else {
        if (requestData.badges) {
          const index = requestData.badges.findIndex(x => x.badgeName === 'badges-apple');
          if (index >= 0) {
            requestData.badges.splice(index, 1);
          }
        }
      }
      if (this.selectedS3ImageList && this.selectedS3ImageList.length > 0) {
        if (requestData.imagesOrVideos && requestData.imagesOrVideos.length === 0) {
          requestData.imagesOrVideos = this.selectedS3ImageList;
        } else {
          requestData.imagesOrVideos = requestData.imagesOrVideos.concat(this.selectedS3ImageList);
        }
      }
      const currentNodeInfo = Object.assign({}, requestData);
      if (this.isEditMode) {
        if (requestData && requestData.controls
          && requestData.controls.length &&
          requestData.controls.length > 0) {
          requestData.targetId = null;
        }
        this.adminService.updateSubFeatureFlow(requestData).subscribe(() => {
          this.showError = false;
          this.showAlertMessages('success', TCCPConstantValues.admin.messages.STEP_UPDATE_SUCCESS_MESSAGE);
          myForm.resetForm();
          this.getSubFeatureFlow(this.stepFormDetails.issueId);
          this.isViewMode = true;
          this.isEditMode = false;
          this.controlName = null;
          this.tileName = null;
          this.setPageMode({
            mode: TCCPConstantValues.admin.FIXED_VALUES.VIEW,
            fromAdmin: false, currentNode: currentNodeInfo, action: 'update'
          });
        });
      } else {
        if (this.selectedTagName !== '') {
          if (requestData && requestData.controls && requestData.controls.length > 0) {
            requestData.controls.forEach(control => {
              if (control.targetId) {
                control.targetId = null;
              }
            });
          }
        }
        this.adminService.insertSubFeatureFlow(requestData).subscribe((response: any) => {
          if (response) {
            this.showError = false;
            this.clearForm();
            myForm.form.markAsPristine();
            myForm.form.markAsUntouched();
            myForm.reset();
            if (this.adminService.fromFeaturePage) {
              this.adminService.getSubFeatureFlow(this.adminService.selectedFeatureTargetId).
                subscribe(prevResponse => {
                  if (prevResponse) {
                    const featureDetails = prevResponse;
                    let prevTargetId;
                    if (featureDetails && featureDetails.Item && featureDetails.Item.controls
                      && featureDetails.Item.controls.length &&
                      featureDetails.Item.controls.length > 0) {
                      featureDetails.Item.controls.forEach(node => {
                        prevTargetId = node.targetId;
                        node.targetId = response.issueId;
                      });
                    } else {
                      prevResponse.targetId = response.issueId;
                    }
                    this.adminService.updateSubFeatureFlow(featureDetails.Item).subscribe((featureResponse: any) => {
                      if (featureResponse) {
                        requestData.issueId = response.issueId;
                        if (requestData.targetId === undefined) {
                          requestData.targetId = null;
                        }
                        requestData.targetId = prevTargetId === undefined ? null : prevTargetId;
                        this.adminService.updateSubFeatureFlow(requestData).subscribe((stepResponse: any) => {
                          if (stepResponse) {
                            this.showAlertMessages('success', 'The Step is added successfully');
                            this.getSubFeatureFlow(response.issueId);
                            this.isViewMode = true;
                            this.isEditMode = false;
                            this.controlName = null;
                            this.tileName = null;
                            this.enteredControlName = null;
                            this.setPageMode({
                              mode: TCCPConstantValues.admin.FIXED_VALUES.VIEW, fromAdmin: false,
                              currentNode: requestData, action: 'add'
                            });
                          }
                        });
                      }
                    });
                  }
                });
            } else {
              this.adminService.getSubFeatureFlow(this.adminService.nodeDetails['previous-node'].issueId).
                subscribe(prevresponse => {
                  if (prevresponse) {
                    const prevRequestData: Flow = <Flow>(prevresponse.Item);
                    if (prevRequestData && prevRequestData.controls && prevRequestData.controls.length &&
                      prevRequestData.controls.length > 0) {
                      prevRequestData.controls.forEach(node => {
                        //  prevRequestData.targetId = null;
                        if (node.controlName === this.adminService.selectedNode['item']['controlName']) {
                          node.targetId = response.issueId;
                        }
                      });
                    } else {
                      prevRequestData.targetId = response.issueId;
                    }
                    requestData.issueId = response.issueId;
                    this.adminService.updateSubFeatureFlow(prevRequestData).subscribe(prevNodeResponse => {
                      if (prevNodeResponse) {
                        if (this.adminService.nodeDetails['previous-node'] &&
                          this.adminService.nodeDetails['previous-node'].controls &&
                          this.adminService.nodeDetails['previous-node'].controls.length &&
                          this.adminService.nodeDetails['previous-node'].controls.length > 0) {
                          this.adminService.nodeDetails['previous-node'].controls.forEach(node => {
                            if (node.controlName === this.adminService.selectedNode['item']['controlName']) {
                              requestData.targetId = this.adminService.selectedNode['item']['targetId'];
                            }
                          });
                        } else {
                          requestData.targetId = this.adminService.nodeDetails['previous-node'].targetId;
                        }
                        this.adminService.updateSubFeatureFlow(requestData).subscribe(currentNodeResponse => {
                          if (currentNodeResponse) {
                            this.showAlertMessages('success', 'The Step is added successfully');
                            this.getSubFeatureFlow(response.issueId);
                            this.isViewMode = true;
                            this.isEditMode = false;
                            this.controlName = null;
                            this.tileName = null;
                            this.enteredControlName = null;
                            this.setPageMode({
                              mode: TCCPConstantValues.admin.FIXED_VALUES.VIEW,
                              fromAdmin: false, currentNode: requestData, action: 'add'
                            });
                          }
                        });
                      }
                    });
                  }
                });
            }
          }
        });
      }
    }
  }

  clearForm() {
    this.enteredControlName = null;
    this.controlName = null;
    this.tileName = null;
    this.showNotes = false;
    this.showTroubleshooting = false;
    this.showFAQ = false;
    this.markAsLastStep = false;
    this.stepFormDetails = <Flow>({
      tagName: null, imagesOrVideos: [], issueId: null,
      controls: [], notes: null, targetId: null, videos: [],
      informationOrQuestion: null, lastModifiedDate: null, type: null, featureType: null, isLastStep: null,
      hasContentSpliter: null, phoneCompatibilty: null, documents: [],
      troubleshoot: <Troubleshoot>{}, reviewComments: [], badges: [], isControlAsButton: false, isImageFromS3: false
    });
    this.playStoreChecked = false;
    this.appStoreChecked = false;
    this.androidLink = '';
    this.iosLink = '';
  }

  onCancel() {
    this.alerts = [];
    if (this.isAddMode || this.isEditMode) {
      this.openCancelDialog();
    }
  }

  openCancelDialog(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      position: { top: '50px' },
      width: '350px',
      data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
      id: 'admin-' + environment.applicationName
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.isEditMode) {
          //  const initialInfo = Object.assign({}, this.initialFlowInfomation);
          //  this.stepFormDetails = initialInfo;
          this.getSubFeatureFlow(this.adminService.selectedStepIssueId);
          this.isViewMode = true;
          this.isEditMode = false;
        }

        if (this.isAddMode) {
          this.isViewMode = true;
          this.isAddMode = false;
          this.clearForm();
        }
      }
    });
  }

  /*   addTileClicked() {
      if (this.tileName == null || this.tileName == '') {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.TILE_MANDATORY_MESSAGE);
      } else {
        const element: HTMLElement = document.getElementsByClassName('iconUploader')[0] as HTMLElement;
        element.click();
      }
    }
   */
  uploadtoS3(fileRequest: File, response: string, type: string, path) {
    this.adminService.uploadtoS3(fileRequest, response, type).subscribe(() => {
      this.stepFormDetails.imagesOrVideos.push(path);
      this.hasImagesOrVideos = this.stepFormDetails.imagesOrVideos.length > 0;
    });
  }

  onFileChange(files: FileList, type: string) {
    this.alerts = [];
    const imageExtensionTypes = ['image/svg', 'image/svg+xml', 'image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
    const iconExtensionTypes = ['image/svg', 'image/svg+xml', 'image/png', 'image/jpg', 'image/jpeg'];
    const videoExtensionTypes = ['video/mp4'];
    let isValid = false;
    if (files[0].type.indexOf('image') !== -1) {
      if (imageExtensionTypes.indexOf(files[0].type) === -1) {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.PNG_FORMAT_MESSAGE);
        this.infoOpenState = false;
        this.contentOpenState = true;
        isValid = false;
      } else {
        isValid = true;
      }
    } else if (files[0].type.indexOf('video') !== -1) {
      if (videoExtensionTypes.indexOf(files[0].type) === -1) {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.MP4_FORMAT_MESSAGE);
        isValid = false;
        this.infoOpenState = false;
        this.contentOpenState = true;

      } else {
        isValid = true;
      }
    } else if (type === '') {
      if (imageExtensionTypes.indexOf(files[0].type) === -1 && videoExtensionTypes.indexOf(files[0].type) === -1) {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.IMAGE_VIDEO_FORMAT_MESSAGE);
        isValid = false;
        this.infoOpenState = false;
        this.contentOpenState = true;

      } else {
        isValid = true;
      }
    } else if (type === 'unknown') {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.IMAGE_VIDEO_FORMAT_MESSAGE);
      isValid = false;
      this.infoOpenState = false;
      this.contentOpenState = true;

    } else {
      let hasControlExists = false;
      if (!this.tileName) {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.TILE_MANDATORY_MESSAGE);
        this.infoOpenState = false;
        this.contentOpenState = true;
        isValid = false;

      } else if (this.tileName === '') {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.TILE_MANDATORY_MESSAGE);
        this.infoOpenState = false;
        this.contentOpenState = true;
        isValid = false;
      } else if (this.tileName && this.tileName !== '') {
        if (this.stepFormDetails.controls && this.stepFormDetails.controls.length === 0) {
          isValid = true;
        } else {
          this.stepFormDetails.controls.forEach((obj) => {
            if (obj && obj.controlType && obj.controlType === 'tile' && obj.controlName === this.tileName) {
              if (!hasControlExists) {
                isValid = false;
                hasControlExists = true;
                this.infoOpenState = false;
                this.contentOpenState = true;
                this.showAlertMessages('error', TCCPConstantValues.admin.messages.TILE_EXISTS_MESSAGE);
              }
            }
          });
          if (!hasControlExists) {
            isValid = true;
          }
        }
      }
      if (isValid) {
        if (iconExtensionTypes.indexOf(files[0].type) === -1) {
          this.showAlertMessages('error', TCCPConstantValues.admin.messages.SVG_PNG_FORMAT_MESSAGE);
          this.infoOpenState = false;
          this.contentOpenState = true;
          isValid = false;
        } else {
          isValid = true;
        }
      }
    }

    if (files[0].name !== '') {
      const ext = files[0].name.split('.').pop();
      this.filename = files[0].name.replace('.' + ext, new Date().getTime() + '.' + ext);
      if (isValid) {
        const fileRequestBody = new ImageRequest();
        fileRequestBody.source = this.adminService.selectedApplication;
        fileRequestBody.contentType = files[0].type;
        fileRequestBody.fileName = this.filename;
        fileRequestBody.contentBase64 = null;
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          if (type === 'icon') {
            this.adminService.uploadImage(fileRequestBody).subscribe((response: any) => {
              if (response) {
                this.handleIconReaderLoaded(files[0], response.url, files[0].type, response.path);
              }
            });
          } else {
            this.adminService.uploadImage(fileRequestBody).subscribe((response: any) => {
              if (response) {
                this.uploadtoS3(files[0], response.url, files[0].type, response.path);
              }
            });
          }
        };
      }
    }
  }

  existenceCheck(controlName: string, controlType: string) {
    let hasControlExists = false;
    if (controlName && controlName !== '') {
      this.stepFormDetails.controls.forEach((obj) => {
        if (obj && obj.controlType && obj.controlType === controlType && obj.controlName === controlName) {
          if (!hasControlExists) {
            hasControlExists = true;
          }
        }
      });
      if (hasControlExists && this.isEditControl) {
        this.stepFormDetails.controls.forEach((obj, index) => {
          if (index === this.editControlIndex) {
            hasControlExists = false;
          }
        });
      }
      return hasControlExists;
    }
  }


  uploadForControl(control, controlIndex) {
    const element: HTMLElement = document.getElementById('uploader-' + control.controlName) as HTMLElement;
    element.click();
  }

  updateControl(controlName: string, controlType: string) {
    this.isEditControl = true;
    this.enteredControlName = controlName;
    if (controlName && controlName !== '') {
      if (this.existenceCheck(controlName, controlType)) {
        if (this.stepFormDetails.controls[this.editControlIndex].controlName !== controlName) {
          this.showAlertMessages('error', TCCPConstantValues.admin.messages.CONTROL_EXISTS_MESSAGE);
        } else {
          this.controlName = '';
          this.enteredControlName = '';
        }
      } else {
        this.stepFormDetails.controls[this.editControlIndex].controlName = controlName;
        this.isEditControl = false;
        this.isEditControl = false;
        this.controlName = '';
        this.enteredControlName = '';
      }
    } else {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.CONTROL_MANDATORY_MESSAGE);
    }
  }

  addControl(controlName: string, controlType: string) {
    this.enteredControlName = controlName;
    this.stepFormDetails.controls = this.stepFormDetails.controls == null ? [] : this.stepFormDetails.controls;
    if (controlName && controlName !== '') {
      if (this.existenceCheck(controlName, controlType)) {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.CONTROL_EXISTS_MESSAGE);
      } else {
        const controls = ({ controlName: controlName, controlType: 'button' }) as Control;
        this.stepFormDetails.controls.push(controls);
        const buttonControls = this.stepFormDetails.controls.map(x => x.controlType === 'button');
        this.hasControls = buttonControls.length > 0;
        this.controlCount = this.controlCount + 1;
        this.controlName = '';
      }
    } else {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.CONTROL_MANDATORY_MESSAGE);
    }
  }


  onControlFileChange(files: FileList, type: string, controlName: string, controlIndex) {
    this.alerts = [];
    const imageExtensionTypes = ['image/svg', 'image/svg+xml', 'image/png', 'image/jpeg', 'image/jpg'];
    const iconExtensionTypes = ['image/svg', 'image/svg+xml', 'image/png', 'image/jpg', 'image/jpeg'];
    const videoExtensionTypes = ['video/mp4'];
    let isValid = false;
    if (files.length > 0) {
      if (files[0].type.indexOf('image') !== -1) {
        if (imageExtensionTypes.indexOf(files[0].type) === -1) {
          this.showAlertMessages('error', TCCPConstantValues.admin.messages.PNG_FORMAT_MESSAGE);
          isValid = false;
        } else {
          isValid = true;
        }
      } else if (type === '') {
        if (imageExtensionTypes.indexOf(files[0].type) === -1 && videoExtensionTypes.indexOf(files[0].type) === -1) {
          this.showAlertMessages('error', TCCPConstantValues.admin.messages.IMAGE_VIDEO_FORMAT_MESSAGE);
          isValid = false;
        } else {
          isValid = true;
        }
      }
      if (files[0].name !== '') {
        const ext = files[0].name.split('.').pop();
        this.filename = files[0].name.replace('.' + ext, new Date().getTime() + '.' + ext);
        if (isValid) {
          const fileRequestBody = new ImageRequest();
          fileRequestBody.source = this.adminService.selectedApplication;
          fileRequestBody.contentType = files[0].type;
          fileRequestBody.fileName = this.filename;
          fileRequestBody.contentBase64 = null;
          const reader = new FileReader();
          reader.readAsDataURL(files[0]);
          reader.onload = () => {
            this.adminService.uploadImage(fileRequestBody).subscribe((response: any) => {
              if (response) {
                this.adminService.uploadtoS3(files[0], response.url, files[0].type).subscribe(() => {
                  const controls = ({
                    controlName: controlName, controlType: 'button',
                    icon: response.path, targetId: null,
                  }) as Control;
                  this.stepFormDetails.controls.splice(controlIndex, 1, controls);
                  this.isEditControl = false;
                });
              }
            });
          };
        }
      }
    }
  }

  isVideo(src) {
    return src.match(/\.(mp4|)$/i);
  }

  isImage(src) {
    return (/\.(jpg|jpeg||png|svg|svg+xml)$/i).test(src);
  }

  changeImageOrder(control, direction) {
    let haveSwapped = false;
    if (this.stepFormDetails && this.stepFormDetails.imagesOrVideos && this.stepFormDetails.imagesOrVideos.length > 0) {
      this.stepFormDetails.imagesOrVideos.forEach((obj, index) => {
        if (control.trim().toLowerCase() === obj.trim().toLowerCase()) {
          const swappingItem = this.stepFormDetails.imagesOrVideos[index];
          if (direction === 'up') {
            if (!haveSwapped) {
              if (index < 1) {
                const swappingIndex = index < 1 ? this.stepFormDetails.imagesOrVideos.length - 1 : index;
                this.stepFormDetails.imagesOrVideos[index] = this.stepFormDetails.imagesOrVideos[swappingIndex];
                this.stepFormDetails.imagesOrVideos[swappingIndex] = swappingItem;
                haveSwapped = true;
              } else {
                this.stepFormDetails.imagesOrVideos[index] = this.stepFormDetails.imagesOrVideos[index - 1];
                this.stepFormDetails.imagesOrVideos[index - 1] = swappingItem;
                haveSwapped = true;
              }
            }
          } else {
            if (!haveSwapped) {
              if (index === this.stepFormDetails.imagesOrVideos.length - 1) {
                const swappingIndex = index === this.stepFormDetails.imagesOrVideos.length - 1 ? 0 : index;
                this.stepFormDetails.imagesOrVideos[index] = this.stepFormDetails.imagesOrVideos[swappingIndex];
                this.stepFormDetails.imagesOrVideos[swappingIndex] = swappingItem;
                haveSwapped = true;
              } else {
                this.stepFormDetails.imagesOrVideos[index] = this.stepFormDetails.imagesOrVideos[index + 1];
                this.stepFormDetails.imagesOrVideos[index + 1] = swappingItem;
                haveSwapped = true;
              }
            }
          }
        }
      });
    }
  }

  changeOrder(control, direction) {
    let haveSwapped = false;
    if (this.stepFormDetails && this.stepFormDetails.controls && this.stepFormDetails.controls.length > 0) {
      this.stepFormDetails.controls.forEach((obj, index) => {
        if (control.controlName.trim().toLowerCase() === obj.controlName.trim().toLowerCase()) {
          const swappingItem = this.stepFormDetails.controls[index];
          if (direction === 'up') {
            if (!haveSwapped) {
              if (index < 1) {
                const swappingIndex = index < 1 ? this.stepFormDetails.controls.length - 1 : index;
                this.stepFormDetails.controls[index] = this.stepFormDetails.controls[swappingIndex];
                this.stepFormDetails.controls[swappingIndex] = swappingItem;
                haveSwapped = true;
              } else {
                this.stepFormDetails.controls[index] = this.stepFormDetails.controls[index - 1];
                this.stepFormDetails.controls[index - 1] = swappingItem;
                haveSwapped = true;
              }
            }
          } else {
            if (!haveSwapped) {
              if (index === this.stepFormDetails.controls.length - 1) {
                const swappingIndex = index === this.stepFormDetails.controls.length - 1 ? 0 : index;
                this.stepFormDetails.controls[index] = this.stepFormDetails.controls[swappingIndex];
                this.stepFormDetails.controls[swappingIndex] = swappingItem;
                haveSwapped = true;
              } else {
                this.stepFormDetails.controls[index] = this.stepFormDetails.controls[index + 1];
                this.stepFormDetails.controls[index + 1] = swappingItem;
                haveSwapped = true;
              }
            }
          }
        }
      });
    }
  }

  handleIconReaderLoaded(fileRequest: File, response: string, type: string, path: string) {
    this.adminService.uploadtoS3(fileRequest, response, type).subscribe(() => {
      this.tileInformation = ({ icon: path, targetId: null, controlName: this.tileName, featureName: null, controlType: 'tile' }) as Control;
      this.stepFormDetails.controls.push(this.tileInformation);
      const tileControls = this.stepFormDetails.controls.map(x => x.controlType === 'tile');
      this.hasTiles = tileControls.length > 0;
      this.tileCount = this.tileCount + 1;
      this.tileName = '';
    });
  }

  preview(stepFormDetails: Flow) {
    const flowArray: string[] = [];
    flowArray.push(stepFormDetails.issueId);
    this.storageService.setFlow(flowArray);
    this.storageService.setPreview(true);
    this.storageService.setSupportTopics('SUPPORT TOPICS', '/admin/flow')
    this.storageService.setVehicleModel('MODEL', '/admin/flow')
    this.storageService.setVehicleYear(2025, '/admin/flow')
    environment.applicationName = this.adminService.selectedApplication;
    this.dialog.open(PreviewDialogComponent, {
      position: {
        top: '10px',
        right: '10px',
        left: '10px',
        bottom: '10px'
      },
      height: '98%',
      width: '100vw',
      maxWidth: '99vw',
      panelClass: 'full-screen-modal',
    });
  }

  editView(stepForm) {
    this.editQuill();
    this.alerts = [];
    this.isEditMode = true;
    this.setPageMode({ mode: TCCPConstantValues.admin.FIXED_VALUES.EDIT, fromAdmin: false });
    this.adminService.nodeBeforeStepChange = this.adminService.selectedNode;
    this.autoSizeTextArea();
    if (stepForm.submitted !== true) {
      this.adminService.stepDataChanged = true;
    } else {
      this.adminService.stepDataChanged = false;
    }
  }

  deleteStep() {
    this.adminService.getSubFeatureFlow(this.adminService.isSelectedNodeExpanded['node'].item.issueId).
      subscribe(prevResponse => {
        this.adminService.getSubFeatureFlow(this.adminService.parentNode['item'].issueId).
          subscribe(parentResponse => {
            if (prevResponse) {
              if (parentResponse) {
                const requestData = prevResponse.Item;
                const parentRequestData = parentResponse.Item;
                if (this.adminService.isSelectedNodeExpanded['node'].item.controls &&
                  this.adminService.isSelectedNodeExpanded['node'].item.controls.length === 0) {
                  if (this.adminService.parentNode && this.adminService.parentNode['item'] &&
                    this.adminService.parentNode['item'].controls &&
                    (typeof (this.adminService.parentNode['item'].controls) === 'object') &&
                    Object.keys(this.adminService.parentNode['item'].controls).length > 0) {
                    parentRequestData.controls.forEach((element, index) => {
                      if (element.controlName === this.adminService.parentNode['item']['controlName']) {
                        parentRequestData.controls[index].targetId = this.adminService.selectedNode['item']['targetId'];
                        requestData['targetId'] = null;
                      }
                    });
                  } else {
                    if (parentRequestData.type.toLowerCase() === 'feature') {
                      parentRequestData.controls[0].targetId = this.adminService.selectedNode['item']['targetId'];
                    } else {
                      if (this.adminService.selectedNode['item'].controls && this.adminService.selectedNode['item'].controls.length > 0) {
                        parentRequestData.targetId = null;
                      } else {
                        parentRequestData.targetId = this.adminService.selectedNode['item']['targetId'];
                      }
                    }
                  }
                } else {
                  if (this.adminService.parentNode && this.adminService.parentNode['item'] &&
                    this.adminService.parentNode['item'].controls &&
                    this.adminService.parentNode['item'].controls.length > 0) {
                    this.adminService.parentNode['item'].controls.forEach((node, controlIndex) => {
                      if (node.controlName === this.adminService.parentNode['item']['controlName']) {
                        parentRequestData.controls[controlIndex].targetId = this.adminService.selectedNode['item']['targetId'];
                      }
                    });
                  } else if (parentRequestData.type.toLowerCase() === 'feature') {
                    parentRequestData.controls[0].targetId = this.adminService.selectedNode['item']['targetId'];
                  } else {
                    if (this.adminService.selectedNode['item'].controls && this.adminService.selectedNode['item'].controls.length > 0) {
                      parentRequestData.targetId = null;
                    } else {
                      parentRequestData.targetId = this.adminService.selectedNode['item']['targetId'];
                    }
                  }
                }

                this.adminService.updateSubFeatureFlow(requestData).subscribe((prevNodeResponse: any) => {
                  if (prevNodeResponse) {
                    this.adminService.updateSubFeatureFlow(parentRequestData).subscribe((currentNodeResponse: any) => {
                      if (currentNodeResponse) {
                        this.adminService.deleteFeatureFlow(this.stepFormDetails.issueId).subscribe(() => {
                          this.showError = false;
                          this.adminService.fromFeaturePage = false;
                          this.callrefreshFeatureTree(
                            {
                              node: this.adminService.expandedNode,
                              issueId: this.stepFormDetails.issueId,
                              type: 'step',
                              action: 'delete'
                            }
                          );
                          /*  this.router.navigateByUrl('admin'); */
                        });
                      }
                    });
                  }
                });
              }
            }
          });
      });
  }

  openDeleteDialog(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      id: 'admin-' + this.adminService.selectedApplication,
      data: !_.isEmpty(this.adminService.isSelectedNodeExpanded['node'].item.controls) ?
        TCCPConstantValues.admin.messages.STEP_DELETE_CONFIRMATION_MESSAGE1 :
        TCCPConstantValues.admin.messages.STEP_DELETE_CONFIRMATION_MESSAGE,
      position: { top: '100px' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteStep();
      }
    });
  }

  markLastStepConfirmation() {
    this.adminService.childrenClone.forEach((item, i) => {
      if (item.issueId === this.stepFormDetails.issueId) {
        if (i === this.adminService.childrenClone.length - 1) {
          this.isLastStepInFlow = true;
        } else {
          this.isLastStepInFlow = false;
          this.markAsLastStep = true;
          this.deleteChildren = this.adminService.childrenClone.slice((i + 1), this.adminService.childrenClone.length);
        }
      }
    });

    if (this.isLastStepInFlow === false) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        data: TCCPConstantValues.admin.messages.MARK_CURRENT_STEP_AS_LAST_MESSAGE,
        id: 'admin-' + this.adminService.selectedApplication,
        position: { top: '100px' }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.markAsLastStep = true;
        } else {
          this.markAsLastStep = false;
        }
      });
    }
  }

  getAllTagName() {
    this.adminService.getAllTagName().subscribe(response => {
      if (response) {
        this.tagNames = response;
      }
    });
  }

  getFlowByIssueId(event) {
    this.getSubFeatureFlow(event.value, true);
  }

  addStep() {
    this.adminService.addStepClicked = true;
    this.isEditMode = false;
    this.adminService.fromFeaturePage = false;
    this.adminService.nodeDetails['previous-node'] = this.stepFormDetails;
    this.adminService.isStepInViewMode = false;
    this.setPageMode({ mode: TCCPConstantValues.admin.FIXED_VALUES.ADD, fromAdmin: false });
    this.isAddMode = true;
  }

  notesChanged(event) {
    if (event.checked === true) {
      this.showNotes = true;
    }

    if ((this.stepFormDetails.notes === '' || this.stepFormDetails.notes == null) && event.checked === false) {
      this.showNotes = false;
    } else {
      this.openNotesDialog(event);
    }
  }

  troubleshootingChanged(event) {
    if (event.checked === true) {
      this.showTroubleshooting = true;
    }

    if ((this.stepFormDetails.troubleshoot.troubleshootingSteps === '' ||
      this.stepFormDetails.troubleshoot.troubleshootingSteps == null) && event.checked === false) {
      this.showTroubleshooting = false;
    } else {
      this.openTroubleshootDialog(event);
    }
  }

  FAQChanged(event) {
    if (event.checked === true) {
      this.showFAQ = true;
    }

    if ((this.stepFormDetails.faqs.faqs === '' ||
      this.stepFormDetails.faqs.faqs == null) && event.checked === false) {
      this.showFAQ = false;
    } else {
      this.openFAQDialog(event);
    }
  }


  lastStepChanged(event) {
    if (event.checked) {
      this.markAsLastStep = true;
      this.markLastStepConfirmation();
    } else {
      this.markAsLastStep = false;
    }
  }

  openNotesDialog(event): void {
    if (event.checked === true) {
      this.showNotes = true;
    }
    if (!event.checked && this.stepFormDetails.notes !== null) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        id: 'admin-' + this.adminService.selectedApplication,
        data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.stepFormDetails.notes = '';
          this.showNotes = false;
        } else {
          this.showNotes = true;
        }
      });
    }
    this.showNotes = true;
  }

  openFAQDialog(event): void {
    if (event.checked === true) {
      this.showFAQ = true;
    }

    if (!event.checked && this.stepFormDetails.faqs.faqs !== null) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        id: 'admin-' + this.adminService.selectedApplication,
        data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.stepFormDetails.faqs.faqs = '';
          this.showFAQ = false;
        } else {
          this.showFAQ = true;
        }
      });
    }
    this.showFAQ = true;
  }

  openTroubleshootDialog(event): void {
    if (event.checked === true) {
      this.showTroubleshooting = true;
    }

    if (!event.checked && this.stepFormDetails.troubleshoot.troubleshootingSteps !== null) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
        id: 'admin-' + this.adminService.selectedApplication
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.stepFormDetails.troubleshoot.troubleshootingSteps = '';
          this.showTroubleshooting = false;
        } else {
          this.showTroubleshooting = true;
        }
      });
    }
    this.showTroubleshooting = true;
  }

  editControlTile(tile, tileIndex) {
    this.isTileControl = true;
    this.editControlIndex = tileIndex;
    this.tileName = tile.controlName;
  }

  editControl(control, controlIndex) {
    this.isEditControl = true;
    this.editControlIndex = controlIndex;
    this.controlName = control.controlName;
  }

  openEditConfirmDialog(control, index): void {
    this.adminService.controlList = Object.assign([], this.stepFormDetails.controls);
    this.adminService.controlInformation = Object.assign({}, control);
    this.adminService.controlInformation['index'] = index;
    const dialogRef = this.dialog.open(EditTileDialogComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event && result.event === 'save') {
        this.stepFormDetails.controls[index].icon = result.data['icon'];
        this.stepFormDetails.controls[index].controlName = result.data['controlName'];
      }
    });
  }

  openPhoneCompatibility(): void {
    const dialogRef = this.dialog.open(PhoneCompatibilityDialogComponent, {
      width: '500px',
      data: this.stepFormDetails.phoneCompatibilty
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event && result.event === 'save') {
        this.stepFormDetails.phoneCompatibilty = result.data;
      }
    });
  }

  openDisclaimer(type?: string): void {
    const cursorPositionForVideo = this.editor.getSelection().index;
    if (type === 'video') {
      const dialogRef = this.dialog.open(VideoUrlDialogComponent, {
        width: '450px'
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && result.event && result.event === 'save') {
          const value = '<spanvideoblock> </spanvideoblock>';
          this.editor.format('spanvideoblock', result.data);
          this.editor.clipboard.dangerouslyPasteHTML(cursorPositionForVideo, value, 'user', { bold: true });
          this.editor.clipboard.dangerouslyPasteHTML(cursorPositionForVideo, '&nbsp;<b url="' + result.data + '">World</b>');
        }
      });
    } else {
      const dialogRef = this.dialog.open(DisclaimerDialogComponent, {
        width: '900px'
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && result.event && result.event === 'save') {
          result.data.forEach(element => {
            const value = '<spanblock onClick="openDisclaimer()">' + element.disclaimerId + '</spanblock>';
            const cursorPosition = this.editor.getSelection().index;
            this.editor.clipboard.dangerouslyPasteHTML(cursorPosition, value, 'user', { bold: true });
            this.editor.setSelection(cursorPosition + element.disclaimerId.toString().length);
          });
        }
      });
    }
  }

  openTroubleshootDisclaimer(): void {
    const dialogRef = this.dialog.open(DisclaimerDialogComponent, {
      width: '900px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event && result.event === 'save') {
        result.data.forEach(element => {
          const value = '<spanblock onClick="openDisclaimer()">' + element.disclaimerId + '</spanblock>';
          const cursorPosition = this.troubleshootEditor.getSelection().index;
          this.troubleshootEditor.clipboard.dangerouslyPasteHTML(cursorPosition, value, 'user', { bold: true });
          this.troubleshootEditor.setSelection(cursorPosition + element.disclaimerId.toString().length);
        });

      }
    });
  }


  openFAQ(): void {
    const dialogRef = this.dialog.open(DisclaimerDialogComponent, {
      width: '900px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event && result.event === 'save') {
        result.data.forEach(element => {
          const value = '<spanblock onClick="openDisclaimer()">' + element.disclaimerId + '</spanblock>';
          const cursorPosition = this.troubleshootEditor.getSelection().index;
          this.troubleshootEditor.clipboard.dangerouslyPasteHTML(cursorPosition, value, 'user', { bold: true });
          this.troubleshootEditor.setSelection(cursorPosition + element.disclaimerId.toString().length);
        });

      }
    });
  }

  getBadgeName(badgeName:string): string{
    let returnVal = '';
    this.badgeList.forEach((item)=>{
      if(badgeName === item.name){
        returnVal = item.iconLink;
      } 
      
    });
    return returnVal;
  }


  openConfirmDialog(item, type): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: 'Are you sure you want to delete the ' + type + '?',
      id: 'admin-' + this.adminService.selectedApplication
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (type === 'Image/Video') {
          this.imageName = item;
          this.stepFormDetails.imagesOrVideos.forEach((imageObj, index) => {
            if (imageObj === this.imageName) {
              this.stepFormDetails.imagesOrVideos.splice(index, 1);
            }
          });
        }
        if (type === 'Control') {
          this.deleteControls = item;
          if (this.stepFormDetails.controls && this.stepFormDetails.controls.length > 0) {
            this.stepFormDetails.controls.forEach((obj, index) => {
              if (obj && obj.controlName && obj.controlName === this.deleteControls.controlName) {
                this.stepFormDetails.controls.splice(index, 1);
              }
            });
            this.controlCount = this.controlCount - 1;
          }
        }
        if (type === 'Tile') {
          this.deleteTileName = item;
          this.adminService.deleteImage(this.deleteTileName).subscribe((response: any) => {
            if (response) {
              if (response === 'File Deleted Successfuly') {
                this.stepFormDetails.controls.forEach((obj, index) => {
                  if (obj.controlType.toLowerCase() === 'tile') {
                    if (obj['icon'] === this.deleteTileName) {
                      this.stepFormDetails.controls.splice(index, 1);
                    }
                  }
                });
              }
            }
            this.tileCount = this.tileCount - 1;
          });
        }
        if (type === 'Compatible Link') {
          if (item.icon) {
            this.adminService.deleteImage(item.icon).subscribe((response: any) => {
              if (response) {
                if (response === 'File Deleted Successfuly') {
                  this.stepFormDetails.phoneCompatibilty = null;
                }
              }
            });
          } else {
            this.stepFormDetails.phoneCompatibilty = null;
          }
        }

        if (type === 'Document Link') {
          this.stepFormDetails.documents.forEach((obj, index) => {
            if (obj === item) {
              this.stepFormDetails.documents.splice(index, 1);
            }
          });
          this.stepFormDetails.documents = this.stepFormDetails.documents.slice();
        }
      }
    });
  }

  // load features based on division selection
  getFeaturesByDivision(event) {
    this.getAllFeature();
  }

  // Fill feature on page load
  getAllFeature() {
    this.adminService.getFlow(null, this.selectedDivision).subscribe(response => {
      if (response) {
        this.features = response;
      }
    });
  }

  getAllDocuments() {
    this.adminService.getAllDocuments().subscribe(response => {
      if (response) {
        this.contents = response;
      }
    });
  }
  // On change of Feature dropdown - load respective Tag names in dropdown
  getStepsByIssueId(event) {
    this.adminService.getStepsByFeature(this.selectedFeature, this.selectedDivision)
      .subscribe(response => {
        if (response) {
          // tag names of all the steps of the selected source support topic
          this.tagNamesByFeature = response.filter(x => x.tagName !== undefined && x.tagName != null && x.tagName !== '');
          this.isDisableSetp = false;
        }
      });
    this.isDisableCopy = true;
  }

  reduceChars(event){
    if((this.textMax -this.stepFormDetails.notes.length)<10){
      this.notesLength = ('0'+ (this.textMax - this.stepFormDetails.notes.length)).slice(-2);
    }else{
    this.notesLength = (this.textMax - this.stepFormDetails.notes.length).toString();
    }
  }

  // Step Dropdown change event
  stepSelectionChange(event) {
    this.isDisableCopy = false; // set to false as user can copy only after a source step is selected
  }

  // Copy button event
  onCopyStep(event) {
    // popup message should only appear if the user has entered any text, Notes text, Image/Videos, Tiles, Controls.
    const initialInfo = Object.assign({}, this.initialFlowInfomation);
    const stepDetails = Object.assign({}, this.stepFormDetails);
    delete stepDetails.tagName;
    delete initialInfo.tagName;
    // if (JSON.stringify(stepDetails) !== JSON.stringify(initialInfo) || this.isEditMode) {
    if (this.isAddMode || this.isEditMode) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '400px',
        data: 'Copy will override all the entered data. Continue?',
        position: { top: '100px' },
        id: 'admin-' + this.adminService.selectedApplication
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.infoOpenState = false;
          this.contentOpenState = true;
          // selectedTagName [i.e. source step issueId ] binded from the selection made on the DOM
          this.getSubFeatureFlow(this.selectedTagName, true);
        }
      });
    } else {
      this.getSubFeatureFlow(this.selectedTagName, true);
    }
  }

  /* Content Spliter Changes */
  contentSpliterChanged(event) {
    const isChecked = event.checked;
    event.checked = false;
    if (this.stepFormDetails.controls && this.stepFormDetails.controls.length && this.stepFormDetails.controls.length > 0) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '400px',
        data: TCCPConstantValues.admin.messages.SPLIT_SCREEN_CONFIRMTION_MESSAGE,
        position: { top: '100px' },
        id: 'admin-' + this.adminService.selectedApplication
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.stepFormDetails.controls = [];
          this.hasContentSpliter = isChecked === true ? true : false;
        } else {
          this.hasContentSpliter = false;
        }
      });
    }
  }

  stepCopyCheckedChanged(event) {
    const isChecked = event.checked;
    event.checked = false;
    this.stepFormDetails.controls = [];
    this.hasStepCopyChecked = isChecked === true ? true : false;
  }


  controlAsTilesChanged(event) {
    const isChecked = event.checked;
    event.checked = false;
    if (this.stepFormDetails.controls && this.stepFormDetails.controls.length && this.stepFormDetails.controls.length > 0) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '400px',
        data: this.isControlAsTile ? TCCPConstantValues.admin.messages.CONTROL_AS_TILE_CONFIRMTION_MESSAGE :
          TCCPConstantValues.admin.messages.CONTROL_AS_BUTTON_CONFIRMTION_MESSAGE,
        position: { top: '100px' },
        id: 'admin-' + this.adminService.selectedApplication
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // this.stepFormDetails.controls = [];
          this.isControlAsTile = isChecked === true ? true : false;
        } else {
          this.isControlAsTile = false;
        }
      });
    }
  }
  openS3ImageDeleteConfirmDialog(index) {
    this.selectedS3ImageList.splice(index, 1);
  }

  onImageOptionChange(event) {
    // this.stepFormDetails.imagesOrVideos = [];
  }

  openS3ImageDialog() {
    const dialogRef = this.dialog.open(PreviewImageComponent, {
      height: '98%',
      width: '100vw',
      maxWidth: '95vw',
      panelClass: 'full-screen-modal',
      data: { type: 'step' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event && result.event === 'save') {
        this.initialImageName = result.data[0];
        if (result.data && result.data.length > 0) {
          result.data.forEach(imageData => {
            const imageName = imageData;
            this.stepFormDetails.imagesOrVideos.push(imageName.replace(this.thumbnilPath, ''));
            this.hasImagesOrVideos = this.stepFormDetails.imagesOrVideos.length > 0;
          });
        }
        this.isImageFromS3 = true;
        this.imageOptionType = 'selectImages';
      }
    });
  }


  editQuill(){
    const el = document.querySelector('.ql-disclaimer');
    this.renderer.addClass(el, 'fa');
    this.renderer.addClass(el, 'fa-comment-o');
    this.renderer.listen(el, 'click', () => {
      this.openDisclaimer();
    });
  }
}

@Component({
  selector: 'app-edit-tile-dialog-component',
  templateUrl: './edit-tile-dialog.component.html',
  styleUrls: ['../admin.component.scss', './step.component.scss']

})
export class EditTileDialogComponent implements OnInit {
  public tileName: string;
  public alerts: any[] = [];
  public thumbnilPath = '';
  public imageSrc = '';
  public filename = '';
  public icon = '';
  public type: string;
  public controlList = [];
  public controlInformation: any = {};
  public fileContent: string | ArrayBuffer;
  // @ViewChild('compressIcons', { static: true }) compressTiles: MatCheckbox;

  constructor(
    public dialogRef: MatDialogRef<StepComponent>, private adminService: AdminService, public commonService: TCCPCommonService) {
  }

  ngOnInit() {
    this.controlList = this.adminService.controlList;
    this.thumbnilPath = TCCPConstantValues.admin.Urls.IMAGE_PATH;
    this.controlInformation = this.adminService.controlInformation;
    this.tileName = this.adminService.controlInformation.controlName;
  }

  close(): void {
    this.dialogRef.close();
  }

  editTileClicked() {
    if (this.tileName == null || this.tileName === '') {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.TILE_MANDATORY_MESSAGE);
    } else {
      const element: HTMLElement = document.getElementsByClassName('editiconUploader')[0] as HTMLElement;
      element.click();
    }
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  // connect with saradha about this, two methods does the same thing
  onEditFileChange(files: FileList, type: string) {
    this.alerts = [];
    const iconExtensionTypes = ['image/svg', 'image/svg+xml', 'image/png', 'image/jpg', 'image/jpeg'];
    let isValid = false;
    if (iconExtensionTypes.indexOf(files[0].type) === -1) {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.SVG_PNG_FORMAT_MESSAGE);
      isValid = false;
    } else {
      isValid = true;
    }

    if (isValid) {
      const ext = files[0].name.split('.').pop();
      this.filename = files[0].name.replace(`. ${ext}`, `${new Date().getTime()} . ${ext}`);
      const imageRequestBody = new ImageRequest();
      imageRequestBody.source = this.adminService.selectedApplication;
      imageRequestBody.contentType = files[0].type;
      imageRequestBody.fileName = this.filename;
      imageRequestBody.contentBase64 = null;
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        this.adminService.uploadImage(imageRequestBody).subscribe((response: any) => {
          if (response) {
            this.uploadtoS3(files[0], response.url, files[0].type, response.path);
          }
        });
      };
    }
  }

  uploadtoS3(fileRequest: File, response: string, type: string, path) {
    this.adminService.uploadtoS3(fileRequest, response, type).subscribe(() => {
      this.controlInformation.icon = path;
    });
  }

  existenceCheck(controlName: string, controlType: string) {
    let hasControlExists = false;
    if (controlName && controlName !== '') {
      this.controlList.forEach((obj, index) => {
        if (obj && obj.controlType && obj.controlType === controlType && obj.controlName === controlName) {
          if (!hasControlExists) {
            hasControlExists = true;
          }
        }
      });
      if (hasControlExists) {
        return hasControlExists;
      }
    }
  }

  onCancel() {
    this.controlInformation.controlName = this.tileName;
    this.dialogRef.close({ event: 'close', data: this.controlInformation });
  }

  onSelect() {
    let hasControlExists = false;
    let isValid = false;
    if (!this.tileName) {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.TILE_MANDATORY_MESSAGE);
      isValid = false;
    } else if (this.tileName === '') {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.TILE_MANDATORY_MESSAGE);
      isValid = false;
    } else if (this.tileName && this.tileName !== '') {
      if (this.controlList && this.controlList.length === 0) {
        isValid = true;
      } else {
        this.controlList.splice(this.controlInformation['index'], 1);
        this.controlList.forEach((obj) => {
          if (obj && obj.controlType && obj.controlType === 'tile' && obj.controlName === this.tileName) {
            if (!hasControlExists) {
              isValid = false;
              hasControlExists = true;
              this.showAlertMessages('error', TCCPConstantValues.admin.messages.TILE_EXISTS_MESSAGE);
            }
          }
        });
        if (!hasControlExists) {
          isValid = true;
        }
      }
    }
    if (isValid) {
      this.controlInformation.controlName = this.tileName;
      this.dialogRef.close({ event: 'save', data: this.controlInformation });
    }
  }
}

@Component({
  selector: 'app-phone-compatability-dialog-component',
  templateUrl: './phone-compatibility.component.html',
  styleUrls: ['../admin.component.scss', './step.component.scss']

})

export class PhoneCompatibilityDialogComponent implements OnInit {
  public alerts: any[] = [];
  public phoneCompatibility: PhoneCompatibility = <PhoneCompatibility>{};
  public editCompatibility: PhoneCompatibility = <PhoneCompatibility>{};
  public imageSrc = '';
  public filename = '';
  public icon = '';
  public type: string;
  public thumbnilPath = '';
  public fileContent: string | ArrayBuffer;

  constructor(
    public dialogRef: MatDialogRef<StepComponent>, private adminService: AdminService,
    public commonService: TCCPCommonService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.phoneCompatibility = this.data;
    this.editCompatibility = Object.assign({}, this.data);
  }

  ngOnInit() {
    this.thumbnilPath = TCCPConstantValues.admin.Urls.IMAGE_PATH;
    this.editCompatibility.linkUrl = '/phone-compatability';
  }

  close(): void {
    this.dialogRef.close();
  }

  uploadIcon() {
    if (this.editCompatibility.displayName == null || this.editCompatibility.displayName === '') {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.DISPLAYNAME_ERROR_MESSAGE);
    } else {
      const element: HTMLElement = document.getElementsByClassName('compatibleIconUploader')[0] as HTMLElement;
      element.click();
    }
  }
  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  onCompatibilityIconChange(files: FileList, type: string) {
    this.alerts = [];
    const iconExtensionTypes = ['image/svg', 'image/svg+xml', 'image/png', 'image/jpg', 'image/jpeg'];
    let isValid = false;
    if (iconExtensionTypes.indexOf(files[0].type) === -1) {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.SVG_PNG_FORMAT_MESSAGE);
      isValid = false;
    } else {
      isValid = true;
    }
    if (isValid) {
      const ext = files[0].name.split('.').pop();
      this.filename = files[0].name.replace(`. ${ext}`, `${new Date().getTime()} . ${ext}`);
      const imageRequestBody = new ImageRequest();
      imageRequestBody.source = this.adminService.selectedApplication;
      imageRequestBody.contentType = files[0].type;
      imageRequestBody.fileName = this.filename;
      imageRequestBody.contentBase64 = null;
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        this.adminService.uploadImage(imageRequestBody).subscribe((response: any) => {
          if (response) {
            this.uploadtoS3(files[0], response.url, files[0].type, response.path);
          }
        });
      };
    }
  }

  uploadtoS3(fileRequest: File, response: string, type: string, path) {
    this.adminService.uploadtoS3(fileRequest, response, type).subscribe(() => {
      this.editCompatibility.icon = path;
    });
  }

  onSelect() {
    let isValid = false;
    if (!this.editCompatibility.displayName) {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.DISPLAYNAME_ERROR_MESSAGE);
      isValid = false;
    } else {
      isValid = true;
    }
    if (isValid) {
      this.dialogRef.close({ event: 'save', data: this.editCompatibility });
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

}
@Component({
  selector: 'app-disclaimer-dialog-component',
  templateUrl: './disclaimer-dialog.component.html',
  styleUrls: ['../admin.component.scss', './step.component.scss']

})
export class DisclaimerDialogComponent implements OnInit {
  public disclaimers: any;
  public disclaimerList = [];
  public disclaimerArray = [];
  public theme: string = null;

  constructor(
    public dialogRef: MatDialogRef<StepComponent>, private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.getDisclaimerList();
    this.theme = `${environment.applicationName}-${this.adminService.selectedApplication}`;
  }
  close(): void {
    this.dialogRef.close();
  }

  getDisclaimerList() {
    this.adminService.getAllDisclaimers().subscribe((response: any) => {
      if (response) {
        this.disclaimers = response.map(x => x.disclaimer).sort((obj1, obj2) => {
          return obj1.disclaimerId - obj2.disclaimerId;
        });
      }
    });
  }

  onDisclaimerChange(disclaimer: any, isChecked: boolean) {
    if (isChecked) {
      this.disclaimerArray.push(disclaimer);
    } else {
      const index = this.disclaimerArray.findIndex(x => x === disclaimer);
      this.disclaimerArray.splice(index, 1);
    }
  }
  onSelect() {
    this.dialogRef.close({ event: 'save', data: this.disclaimerArray });
  }

  onCancel() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'app-preview-dialog-component',
  templateUrl: './preview-dialog.component.html',
  styleUrls: ['../admin.component.scss', './step.component.scss']

})
export class PreviewDialogComponent implements OnInit {

  public theme: string;
  constructor(
    public dialogRef: MatDialogRef<StepComponent>,
    private storageService: TCCPLocalStorageService, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.theme = environment.applicationName;
  }
  close(): void {
    const flowArray: string[] = [];
    this.storageService.setFlow(flowArray);
    environment.applicationName = 'admin';
    this.storageService.setPreview(false);
    this.dialogRef.close();
  }

}



@Component({
  selector: 'app-video-url-dialog-component',
  templateUrl: './video-url-dialog.component.html',
  styleUrls: ['../admin.component.scss', './step.component.scss']

})
export class VideoUrlDialogComponent implements OnInit {
  public videoURL: string = null;

  constructor(
    public dialogRef: MatDialogRef<StepComponent>, private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
  }
  close(): void {
    this.dialogRef.close();
  }

  onSelect() {
    this.dialogRef.close({ event: 'save', data: this.videoURL });
  }

  onCancel() {
    this.dialogRef.close();
  }

 


}
